import { Database } from '@monorepo/supabase-types'
import { createBrowserClient } from '@supabase/ssr'
import { dropCorruptAuthCookiesInBrowser } from '@monorepo/supabase-middleware-user/auth-cookies'

export type * from '@monorepo/supabase-types/additional-types'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || ''
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || ''

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing NEXT_PUBLIC_SUPABASE_URL or NEXT_PUBLIC_SUPABASE_ANON_KEY')
}

export function createClient() {
  // An auth cookie @supabase/ssr can't decode would make the client's auth calls throw
  dropCorruptAuthCookiesInBrowser()
  return createBrowserClient<Database>(process.env.NEXT_PUBLIC_SUPABASE_URL!, process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!)
}
